<template>
  <div
    :class="[wrapperClass]"
    class="form_field input-with-btn w-100"
  >
    <input
      :id="uniqueId"
      v-model="model"
      :class="{ pr0: !model }"
      :placeholder="placeholder || `${$t('search_item')}...`"
      :style="{ paddingLeft: inputPaddingLeft }"
      autocomplete="off"
      class="form_input"
      type="text"
      v-bind="attrs"
    >
    <label
      v-if="label"
      ref="labelRef"
      :for="uniqueId"
      class="form_label"
    >
      {{ label }}
    </label>

    <button
      v-if="model && clearable"
      class="btn wh43 btn_clear input_btn"
      @click="model = null"
    >
      <i class="i-times f14" />
    </button>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  showSearchIcon: {
    type: Boolean,
    default: false,
  },
  wrapperClass: {
    type: String,
    default: '',
  },
  clearable: {
    type: Boolean,
    default: true,
  },
});
const model = defineModel();
const attrs = useAttrs();
const uniqueId = useId();
const labelRef = ref<HTMLElement | null>(null);

const labelWidth = ref(50);

onMounted(() => {
  if (labelRef.value) {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        labelWidth.value = entry.contentRect.width + 20;
      }
    });
    observer.observe(labelRef.value);
    onBeforeUnmount(() => observer.disconnect());
  }
});

const inputPaddingLeft = computed(() => `${labelWidth.value}px`);
</script>

<style lang="scss" scoped>
.form_field {

  .form_label {
    position: absolute;
    left: 12px;
    top: -3px;
    color: var(--surfaces-on-surface-variable);
    font-size: 14px;
  }

  .form_input {
    padding-left: 50px;

    &.pr0 {
      padding-right: 0;
    }
  }
}
</style>
